import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import { CodeXml, Home } from "lucide-react";

import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail,
} from "../../components/ui/sidebar";

import AdminPortalSidebar from "./AdminPortalSidebar";
import HomeSidebar from "./HomeSidebar";
import ProjectAccessSidebar from "./ProjectAccessSidebar";
import HazardSidebar from "./HazardSidebar";
import SecondarySidebar from "./SecondarySidebar";
import UserSidebar from "./UserSidebar";

const AppSidebar = () => {
  const location = useLocation();
  const [locationTokens, setLocationTokens] = useState([]);

  useEffect(() => {
    const tokens = location.pathname.split("/");
    tokens.shift();

    setLocationTokens(tokens);
  }, [location]);

  return (
    <Sidebar collapsible="icon">
      {/* Sidebar Header */}
      <SidebarHeader>
        <SidebarMenu>
          <Link to="/">
            <SidebarMenuItem>
              <SidebarMenuButton size="lg" asChild className="cursor-pointer">
                <div>
                  <div className="flex aspect-square size-8 items-center justify-center rounded-lg bg-sidebar-primary text-sidebar-primary-foreground">
                    <CodeXml className="size-4" />
                  </div>

                  <div className="grid flex-1 text-left text-sm leading-tight">
                    <span className="truncate font-semibold">
                      AI Safety Log
                    </span>

                    <span className="truncate text-xs">Allayze</span>
                  </div>
                </div>
              </SidebarMenuButton>
            </SidebarMenuItem>
          </Link>

          <Link to="/">
            <SidebarMenuItem className="mt-4">
              <SidebarMenuButton asChild tooltip="Home">
                <div>
                  <Home />
                  <span>Home</span>
                </div>
              </SidebarMenuButton>
            </SidebarMenuItem>
          </Link>
        </SidebarMenu>
      </SidebarHeader>

      {/* Sidebar Content */}
      <SidebarContent>
        {/* Home Sidebar */}
        {(location.pathname === "/" ||
          (locationTokens.length < 2 && locationTokens[0] === "projects")) && (
          <HomeSidebar />
        )}

        {/* Project Access Sidebar */}
        {locationTokens[0] === "projects" && locationTokens[2] === "access" && (
          <ProjectAccessSidebar />
        )}

        {/* Hazard Sidebar */}
        {locationTokens[0] === "projects" &&
          locationTokens[2] === "hazards" && <HazardSidebar />}

        {/* Secondary Sidebar */}
        <SecondarySidebar />

        {/* Admin Portal Sidebar */}
        {location.pathname.includes("admin-portal") && <AdminPortalSidebar />}
      </SidebarContent>

      {/* Sidebar Footer */}
      <SidebarFooter className="mb-4">
        <SidebarMenu>
          {/* User Sidebar */}
          <UserSidebar />
          <SidebarRail />
        </SidebarMenu>
      </SidebarFooter>
    </Sidebar>
  );
};

export default AppSidebar;
